<template>
  <div class="mt-12 bg-white shadow-sm overflow-hidden sm:rounded-lg">
    <div class="px-4 py-5 sm:px-6">
      <div class="sm:flex-auto">
        <h1 class="text-xl font-semibold text-gray-900">Variants</h1>
        <p class="mt-2 text-sm text-gray-700">
          {{ $t("A list of all the variants of the products") }}
        </p>
      </div>
    </div>
    <Table :data="variants" :columns="variantColumns">
      <template #name="{ row }">
        <div class="flex items-center">
          <div class="h-10 w-10 shrink-0">
            <img class="h-10 w-10 rounded-full" :src="row.imageUrl" alt="" />
          </div>
          <div class="ml-4">
            <div class="font-medium text-gray-900">
              {{ row.title }}
            </div>
            <div class="text-gray-500">{{ row.vendor }}</div>
          </div>
        </div>
      </template>

      <template #category="{ row }">
        <div class="text-gray-900">
          {{ $t(`contract_distributions.category.${row.category}`) }}
        </div>
      </template>

      <template #price="{ row }">
        <div class="text-gray-900">
          {{ formatPrice(row.price, row.currencyCode) }}
        </div>
      </template>

      <template #source="{ row }">
        {{ row.source }}
      </template>

      <template #reference="{ row }">
        {{ getReferenceId(row) }}
      </template>

      <template #contracts="{ row }">
        <SecondaryButton class="border-primary" @click="showVariantInformations(row)">
          <EyeIcon class="h-5 w-5" aria-hidden="true" />
        </SecondaryButton>
      </template>
    </Table>
  </div>
  <VariantDetails :variant="variantToShow" @close="closeVariantDetailsModal" />
</template>
<script>
import { EyeIcon } from "@heroicons/vue/solid";
import { SecondaryButton, Table, formatPrice, isPresent } from "@estaly/ui";
import VariantDetails from "@/views/store/products/details/variant/details/VariantDetails.vue";

export default {
  components: {
    SecondaryButton,
    EyeIcon,
    VariantDetails,
    Table,
  },
  data: () => {
    return {
      variantToShow: null,
    };
  },
  computed: {
    variantColumns() {
      return [
        {
          field: "name",
          label: this.$t("Name"),
          slot: "name",
        },
        {
          field: "category",
          label: this.$t("Category"),
          slot: "category",
        },
        {
          field: "price",
          label: this.$t("Price incl. taxes"),
          slot: "price",
        },
        {
          field: "source",
          label: this.$t("Source"),
          slot: "source",
        },
        {
          field: "referenceId",
          label: this.$t("Reference"),
          slot: "reference",
        },
        {
          field: "contracts",
          label: this.$t("Contracts"),
          slot: "contracts",
        },
      ];
    },
  },
  methods: {
    formatPrice,
    showVariantInformations(variant) {
      this.variantToShow = variant;
    },
    closeVariantDetailsModal() {
      this.variantToShow = null;
    },
    getReferenceId(variant) {
      if (!isPresent(variant.referenceId)) return "";
      const parts = variant.referenceId.split("/");
      return parts[parts.length - 1];
    },
  },
  props: ["variants", "productId"],
};
</script>
